module.exports = __webpack_public_path__ + "img/modulo_VCF.1d16553.svg";